import React, { Component } from 'react';
import './styles.css'

class Nietoform extends Component{

    state = { 
        data: this.props.data,
        user: '',
        pass: '',
        description: ''        
    }

    onSubmit = e => {  
        if(this.props.data.some(nieto => nieto.user === this.state.user)){
            alert("User Registred");
            this.textUser.focus();
            e.preventDefault();
        } else{
            this.props.addNieto(this.state.user, this.state.pass, this.state.description); 
            e.preventDefault(); 
        }              
    }

    onChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render(){
        return(
            <div className="b-form">
                <div>
                    <h2>Add New User</h2>
                    <form 
                        onSubmit={this.onSubmit} 
                        className="form-addNieto" 
                        > 
                        <input
                            className="txtUser" 
                            name="user"
                            type="text" 
                            placeholder="Write an User Name" 
                            onChange={this.onChange} 
                            value={this.state.user}  
                            required           
                            autoFocus={true}   
                            ref={ (input) => ( this.textUser = input )}
                        />
                        
                        <input 
                            className="txtPass" 
                            name="pass"
                            type="text" 
                            placeholder="Write a Password" 
                            onChange={this.onChange} 
                            value={this.state.pass} 
                            required 
                            ref={ (input) => ( this.textPass = input )}
                        />
                        
                        <textarea 
                            className="txtDescription" 
                            name="description" 
                            placeholder="Write a Description" 
                            onChange={this.onChange} 
                            required 
                            ref={ (input) => ( this.textDescription = input )}
                            value={this.state.description} >                                
                        </textarea>
                        
                        <input
                            className="btnEnviar" 
                            type="submit" 
                            value="Add"
                        /> 
                    </form>
                </div>
            </div>
        )
    }
}

export default Nietoform;

